import {TFunction} from 'i18next';
import {BuyButton} from './BuyButton';
import NiceModal from '@ebay/nice-modal-react';
import {PrecommandeModal} from '@/domains/ligneProduit/PrecommandeModal';
import {ItemCatalogue2StateFF} from 'ff-common';

export const PrecommandeButton: React.FC<{
  itemState: ItemCatalogue2StateFF;
  t: TFunction;
}> = ({itemState, t}) => {
  return (
    <BuyButton
      libelle={t('bouton_achat.preco')}
      onClick={() => {
        NiceModal.show(PrecommandeModal, {
          itemState,
        });
      }}
      isSubmitting={false}
    />
  );
};
